import { useAuthStore }                                   from '@store/authStore'
import { hasPermission, hasAnyPermission, hasAllPermissions } from '@utils/permissions'

/**
 * usePermission — component-level permission checks.
 *
 * Returns { can, canAny, canAll, permissions, role }.
 * Reads the authenticated user's permissions array from authStore.
 */
export function usePermission() {
  const user = useAuthStore((s) => s.user)

  const permissions = user?.permissions ?? []

  function can(permission) {
    return hasPermission(permissions, permission)
  }

  function canAny(perms) {
    return hasAnyPermission(permissions, perms)
  }

  function canAll(perms) {
    return hasAllPermissions(permissions, perms)
  }

  return { can, canAny, canAll, permissions, role: user?.role ?? null }
}
